import { webflowLiblary, IWebflowLiblary } from './webflow';
import { bubbleLiblary, IBubbleLiblary } from './bubble';

export interface Window {
    webflow: IWebflowLiblary;
    bubble: IBubbleLiblary;
}

if (typeof window !== 'undefined') {
    (window as unknown as Window).webflow = webflowLiblary;
    (window as unknown as Window).bubble = bubbleLiblary;
}
